module.exports = __webpack_public_path__ + "img/btn_share.8c945f42.png";